import Http from '../../http';

export const fetchCampaign = (userId) => {
  return Http.get(`/surveys/campaign`, { userId });
};

export const submitCampaign = (data) => {
  return Http.post(`/surveys/response`, data, false);
};

export const rejectCampaign = (userCampaignId) => {
  return Http.patch(
    `/surveys/usercampaign/${userCampaignId}`,
    { status: 'rejected' },
    false,
  );
};
